const palette = {
  transparent: 'transparent',

  white: '#fff',

  black: '#141414',
  blackHard: '#1E2D3D',

  grey: '#4c6176',
  greyLight: '#607B96',

  purple: '#5565E8',
  violet: '#c98bdf',
  green: '#43d9ad',
  orange: '#fea55f',
  red: '#ff3218',
}

export const color = {
  transparent: palette.transparent,

  white: palette.white,
  black: palette.black,

  text: palette.black,
  textPrimary: palette.white,
  textSecondary: palette.grey,
  textThird: palette.greyLight,

  textSuccess: palette.green,
  textHint: palette.orange,
  textHintSecond: palette.purple,
  textHintThird: palette.violet,

  pageBg: palette.white,

  elementBg: palette.white,
  elementBgSecond: palette.blackHard,
  elementBgThird: palette.purple,

  elementBorder: palette.blackHard,
  elementBorderSecond: palette.greyLight,

  buttonBg: palette.blackHard,
  buttonBgSecond: palette.white,
  buttonBgThird: palette.orange,

  inputColor: palette.greyLight,
  tooltipColor: palette.blackHard,

  scrollbarColor: palette.greyLight,
  scrollbarColorBg: palette.white,

  default: palette.purple,

  success: palette.green,
  warning: palette.orange,
  danger: palette.red,

  modalBg: palette.white,
}
